import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { usePageTitle } from "../lib/usePageTitle";

const SeoCtx = createContext({});

export function SeoProvider({ children }) {
  const [settings, setSettings] = useState({});
  useEffect(() => { api.get("/seo/settings").then((r) => setSettings(r.data || {})).catch(console.error); }, []);
  return <SeoCtx.Provider value={settings}>{children}</SeoCtx.Provider>;
}

const fill = (tpl, vars) => (tpl || "").replace(/\{(\w+)\}/g, (_, k) => (vars[k] ?? "")).replace(/\s{2,}/g, " ").trim();

// key ∈ home | city | store | product — vars: {ville, boutique, produit, categorie, extrait}
export function useSeoTitle(key, vars, ready = true) {
  const s = useContext(SeoCtx);
  const title = ready ? fill(s[`${key}_title`], vars) : undefined;
  const desc = ready ? fill(s[`${key}_description`], vars) : undefined;
  usePageTitle(title || undefined, desc || undefined);
}
